module.exports = __webpack_public_path__ + "assets/img/logo.88409ad8.png";